import React, { useContext, useEffect, useState, useReducer } from "react";

import ABMContext from "./context/ABMContext";
import ABMReducer, { initialState } from "./context/ABMReducer";
import PantallaContext from "../context/PantallaContext";
import FuncionesContext, { getAtributo } from "../context/FuncionesContext";
import { FileProvider } from "./context/FileContext";
import { useRefStore } from "../../..";
import { addsql } from "../context/PantallaReducer";
import { transformarFechaISOaMySQL } from "./componentes/inputs/Fecha_simple";

const ABMProvider = ({
  configuracion,
  id,
  children,
  nollamar,
  params,
  modalProps,
  qsBody = {},
}) => {
  const { configuraciones_ref, loadingPantalla, configuraciones_padre } =
    useContext(PantallaContext);
  const { getConfiguracion, ABMSubmit, FormularioSubmit, requestErrorHandler } =
    useContext(FuncionesContext);
  const modoAlta = configuracion.opciones.modo === "alta";

  const [state, dispatch] = useReducer(ABMReducer, initialState);

  const [refState, setRefState] = useRefStore();

  const [loading, setLoading] = useState(true);

  const id_a = configuracion.opciones.id_a;
  const usar_id_datos = configuracion.opciones.abm_id_datos === "s";

  const { parametro_nombre } = configuracion.opciones;
  useEffect(() => {
    if (params && parametro_nombre && parametro_nombre !== "") {
      qsBody.id = params[parametro_nombre];
    }
  });

  useEffect(() => {
    dispatch({
      type: "SET_CABECERAS",
      payload: configuracion.cabeceras,
    });
    dispatch({
      type: "SET_DATOS",
      payload: configuracion.datos,
    });
    dispatch({
      type: "SET_OPCIONES",
      payload: configuracion.opciones,
    });
    dispatch({
      type: "ADD_CONFIGURACIONES_REF",
      payload: configuracion.cabeceras,
    });

    // SETEO VALORES DE FORMULARIO CUANDO HAY ID CON VALORES DE DB
    const formularioValor = {};
    const formularioInicial = {};
    configuracion.datos.forEach((dato) => {
      configuracion.cabeceras.forEach((cab) => {

        // const permite_null = cab.permite_null === "s";
        const procesarValor = (tipo, def, modoAlta, cab) => {
          let valor = dato[cab.id_a];
          try {
            const { esFecha, esSelect } = tipo
            if (esFecha) {
              return transformarFechaISOaMySQL(modoAlta ? def : valor, cab.fecha_formato);
            }
            if (esSelect) {
              const target = modoAlta ? def : valor;

              // eslint-disable-next-line eqeqeq
              let validOption = cab.opciones.find((op) => op.value == target);

              // if ((valor === undefined || valor === null) && !modoAlta) {
              if (!modoAlta && !validOption) {
                // Si no es modoAlta y el select es enlazable, no viene con las opciones por lo que no hay validOption

                // eslint-disable-next-line eqeqeq
                validOption = { value: valor }; //cab.opciones.find((op) => op.value == def);
              }
              return validOption ? validOption.value : null;
            }
            // console.log(cab.id_a, "modoalta:", modoAlta, " => valor:", modoAlta ? def : valor)
            return modoAlta ? def : valor;
          } catch (err) {
            console.error(cab)
          }
        }

        const setValor = (key, valor) => {
          formularioInicial[key] = valor; // siempre setea inicial
          if (esObligatorio || valor) {
            // solo setea actual si valor válido
            formularioValor[key] = valor;
          }
        };
        const fillTipo = (cab) => {
          const tipo = { esSelect: false, esFecha: false }
          tipo.esSelect = ["select", "autocompletar"].includes(cab.componente);
          tipo.esFecha = ["input_fecha", "fecha_simple", "fecha"].includes(
            cab.componente
          );
          return tipo
        }

        const esObligatorio = cab.permite_null === "n";
        const esGrupo = ['grupo_columnas'].includes(cab.componente)

        if (esGrupo) {
          cab.sc_hijos.forEach(cabh => {
            let valor = dato[cab.id_a];
            const tipo = fillTipo(cabh)
            if (esObligatorio && !valor) {
              valor = undefined;
            }
            const def = getAtributo("default", dato, cabh);

            const valorProcesado = procesarValor(tipo, def, modoAlta, cabh);

            if (cabh.clave_envio && cabh.clave_envio.trim() !== "") {
              setValor(cabh.clave_envio, valorProcesado);
            }
            if (cabh.componente === "select" || cabh.componente === "autocompletar") {
              setValor(
                cabh.id_a + "_op",
                cabh.opciones.find((op) => op.value == valorProcesado)
              );
            }
            setValor(cabh.id_a, valorProcesado);

          })
        } else {
          let valor = dato[cab.id_a];
          const tipo = fillTipo(cab)
          if (esObligatorio && !valor) {
            valor = undefined;
          }
          const def = getAtributo("default", dato, cab);

          const valorProcesado = procesarValor(tipo, def, modoAlta, cab);

          if (cab.clave_envio && cab.clave_envio.trim() !== "") {
            setValor(cab.clave_envio, valorProcesado);
          }
          if (cab.componente === "select" || cab.componente === "autocompletar") {

            setValor(
              cab.id_a + "_op",
              cab.opciones.find((op) => op.value == valorProcesado)
            );
          }

          setValor(cab.id_a, valorProcesado);

        }
      });
    });

    // AGREGA UPDATE_ID SI VIENE EN DATOS Y NO EN RUTA
    const _id = getAtributo(
      "update_id",
      configuracion.datos?.length > 0
        ? configuracion.datos[0]
        : configuracion.datos,
      configuracion.opciones
    );
    const regex = /^-?\d+$/;
    if (typeof _id === "number" || regex.test(_id)) {
      if (_id || id) {
        formularioValor["id"] = _id || id;
      }
    }
    ///////////////////////////////////////////////////
    dispatch({
      type: "SET_FORMULARIO_MULTIPLE",
      payload: formularioValor,
    });
    dispatch({
      type: "SET_FORMULARIO_INICIAL_MULTIPLE",
      payload: formularioInicial,
    });

    setFormularioObligatorio(configuracion, dispatch);

    dispatch({
      type: "SET_LOADING",
      payload: false,
    });
    setLoading(false);
  }, [
    loadingPantalla,
    id,
    configuracion.cabeceras,
    configuracion.datos,
    configuracion.opciones,
    configuracion,
    modoAlta,
  ]);

  const callAPI = async ({ params }) => {
    dispatch({
      type: "SET_LOADING",
      payload: true,
    });
    setLoading(true);
    return await getConfiguracion(
      id_a,
      qsBody,
      params,
      configuraciones_padre[id_a]
    ).then((res) => {
      if (res.status >= 400) {
        requestErrorHandler(res);
      }
      dispatch({
        type: "SET_CABECERAS",
        payload: res.data.cabeceras,
      });
      dispatch({
        type: "SET_DATOS",
        payload: res.data.datos,
      });
      dispatch({
        type: "SET_OPCIONES",
        payload: res.data.opciones,
      });
      dispatch({
        type: "ADD_CONFIGURACIONES_REF",
        payload: res.data.cabeceras,
      });
      setRefState({ sql: addsql(res.data.sql, refState.sql) });

      return res.data;
    });
  };

  const guardarAPI = async ({ params }) => {
    setLoading(true);
    // AGREGA UPDATE_ID SI VIENE EN DATOS Y NO EN RUTA
    const _id = getAtributo(
      "update_id",
      configuracion.datos?.length > 0
        ? configuracion.datos[0]
        : configuracion.datos,
      configuracion.opciones
    );
    if (usar_id_datos) {
      qsBody.id = _id;
      params.set("id", _id);
    }

    ///////////////////////////////////////////////////

    return await ABMSubmit({
      id_a,
      qsBody,
      params,
      opciones: configuracion.opciones,
      setLoading,
      data: configuracion.datos[0]
    })
      .then((res) => {
        if (res.status >= 400) {
          requestErrorHandler(res);
        }
        setLoading(false);
        return res;
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return err;
      });
  };

  const enviarFormulario = async ({ params }) => {
    setLoading(true);
    return await FormularioSubmit({
      id_a,
      qsBody,
      params,
      opciones: configuracion.opciones,
      setLoading,
      data: configuracion.datos[0],
    })
      .then((res) => {
        if (res.status >= 400) {
          requestErrorHandler(res);
        }

        setLoading(false);
        return res;
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return err;
      });
  };

  const submit = { abm: guardarAPI, formulario: enviarFormulario };

  useEffect(() => {
    if (configuracion.opciones.tipo.nombre?.toLowerCase() === "formulario")
      return;

    if (params && parametro_nombre) {
      if (id != params[parametro_nombre]) {
        callAPI({ params })
          .then(async (configuracion) => {
            const formularioValor = {};
            await Promise.all(
              configuracion.datos.map(async (dato) => {
                await Promise.all(
                  configuracion.cabeceras.map(async (cab) => {
                    let valor = dato[cab.id_a];
                    if (
                      (!cab.permite_null || cab.permite_null !== "s") &&
                      !valor
                    ) {
                      valor = undefined;
                    }
                    formularioValor[cab.id_a] = valor;
                  })
                );
              })
            );

            dispatch({
              type: "SET_FORMULARIO_MULTIPLE",
              payload: formularioValor,
            });
          })
          .finally(() => {
            dispatch({
              type: "SET_LOADING",
              payload: false,
            });
            setLoading(false);
          });
      }
    }
    //useEffect para actualizar datos a control
    if (configuraciones_ref[id_a] === 1) return;

    if (nollamar) return;
    // console.log("call api ??");
    callAPI({}).finally(() => {
      dispatch({
        type: "SET_LOADING",
        payload: false,
      });
      setLoading(false);
    });
  }, [configuraciones_ref[id_a]]);

  return (
    <FileProvider>
      <ABMContext.Provider
        value={{
          datos: state.datos,
          cabeceras: state.cabeceras,
          opciones: state.opciones,
          valorFormulario: state.formularioValor,
          formularioInicial: state.formularioInicial,
          configuraciones_cab: state.configuraciones_cab,
          modalProps,
          state,
          id: usar_id_datos
            ? getAtributo(
              "update_id",
              configuracion.datos?.length > 0
                ? configuracion.datos[0]
                : configuracion.datos,
              configuracion.opciones
            )
            : id,
          loading: loading,
          params,
          id_a,
          qsBody,
          ABMDispatch: dispatch,
          Dispatch: dispatch,
          dispatch: dispatch,
          callAPI,
          submit: submit[configuracion.opciones.tipo.nombre?.toLowerCase()],
          obligatorios: state.obligatorio,
          modoAlta,
        }}
      >
        {state.loading && loading ? (
          <div
            style={{
              backgroundColor: "rgba(200,150,100,0.5)",
              position: "fixed",
              width: "100vw",
              height: "100vh",
              zIndex: 2000,
              cursor: "wait",
            }}
          >
            CARGANDO....
          </div>
        ) : (
          children
        )}
      </ABMContext.Provider>
    </FileProvider>
  );
};

export default ABMProvider;

function _setFormularioObligatorio(configuracion, dispatch) {
  const checkAndDispatch = (item) => {
    // Si permite_null es "n", disparamos la acción
    if (item.permite_null === "n") {
      dispatch({
        type: "SET_FORMULARIO_OBLIGATORIO",
        payload: { id_a: item.id_a },
      });
    }

    // Si el item tiene hijos, recursivamente llamamos a checkAndDispatch en cada hijo
    if (item.sc_hijos && item.sc_hijos.length > 0) {
      item.sc_hijos.forEach((child) => checkAndDispatch(child));
    }
  };

  // Empezamos el proceso para cada cabecera en la configuración
  configuracion.cabeceras.forEach((cab) => checkAndDispatch(cab));
}

function setFormularioObligatorio(configuracion, dispatch) {
  const ids = new Set();

  const traverse = (item) => {
    if (!item) return;
    if (item.permite_null === "n" && item.id_a != null) {
      ids.add(item.id_a);
    }
    if (Array.isArray(item.sc_hijos) && item.sc_hijos.length) {
      item.sc_hijos.forEach(traverse);
    }
  };

  // Si configuracion o cabeceras vienen undefined, evitamos crash
  if (configuracion && Array.isArray(configuracion.cabeceras)) {
    configuracion.cabeceras.forEach(traverse);
  }

  // Un único dispatch con el array final (reemplaza totalmente el anterior)
  dispatch({
    type: "SET_FORMULARIO_OBLIGATORIOS",
    payload: { obligatorio: Array.from(ids) },
  });
}

function verificarValores(obj, keys, dispatch) {
//  console.log("verificarValores", obj, keys);
  for (const key of keys) {
    if (
      !(key in obj) ||
      obj[key] === null ||
      obj[key] === undefined ||
      obj[key] === ""
    ) {
      dispatch({
        type: "SET_FORMULARIO_ERROR",
        payload: { id_a: key, valor: true },
      });
      return false;
    }
  }
  return true;
}
